module.exports = __webpack_public_path__ + "fonts/iconfont.a24239f.woff2";